import { render, staticRenderFns } from "./report-settings.vue?vue&type=template&id=44108b9f&scoped=true&"
import script from "./report-settings.vue?vue&type=script&lang=ts&"
export * from "./report-settings.vue?vue&type=script&lang=ts&"
import style0 from "./report-settings.vue?vue&type=style&index=0&id=44108b9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44108b9f",
  null
  
)

export default component.exports